export default "__VITE_PUBLIC_ASSET__862894ca__"